<script setup lang="ts">
import { Menu as MenuType } from '@types';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import HeaderMenuButton from '@/layouts/main/header/components/HeaderMenuButton.vue';

// Properties
const props = withDefaults(defineProps<{
    item: MenuType,
    block?: boolean,
}>(), {
    block: false,
});

// Computed
const hasItems = computed<boolean>(() => props.item.items.length > 0);
</script>

<template>
    <template v-if="!hasItems">
        <HeaderMenuButton
            :item="item"
            :block="block"
        />
    </template>
    <template v-else>
        <div>
            <Popover class="relative space-y-4 md:space-y-0">
                <PopoverButton
                    class="relative z-30 focus-visible:outline-none"
                    :class="{'w-full': block}"
                    v-slot="{ open }"
                >
                    <HeaderMenuButton
                        :item="item"
                        :open="open"
                        :block="block"
                    />
                </PopoverButton>

                <transition
                    enter-active-class="transition duration-200 ease-out"
                    enter-from-class="translate-y-1 opacity-0"
                    enter-to-class="translate-y-0 opacity-100"
                    leave-active-class="transition duration-150 ease-in"
                    leave-from-class="translate-y-0 opacity-100"
                    leave-to-class="translate-y-1 opacity-0"
                >
                    <PopoverPanel
                        class="md:absolute md:z-10 md:left-1/2 md:-top-4 md:-translate-x-1/2 md:px-4 md:pt-18 md:pb-4 md:bg-gray-900 md:border md:border-orange-400/35 md:rounded-2xl md:pointer-events-none md:min-w-[calc(100%+(var(--spacing)_*_8))]"
                        v-slot="{ close }"
                    >
                        <div class="space-y-4 pointer-events-auto">
                            <template v-for="sub in item.items" :key="sub.id">
                                <HeaderMenuButton
                                    :item="sub"
                                    block
                                    word-break
                                    @click="close"
                                />
                            </template>
                        </div>
                    </PopoverPanel>
                </transition>
            </Popover>
        </div>
    </template>
</template>

<style scoped>

</style>
